import React from 'react';
import SortingSharedPage from './SortingSharedPage';

const SortingDashboardPage: React.FC = () => {
    return <SortingSharedPage />;
};

export default SortingDashboardPage;

